export * from '@styles/design-tokens/Output/styles.enums';
export var State;
(function (State) {
    State["Selected"] = "selected";
    State["Disabled"] = "disabled";
    State["Active"] = "active";
    State["Error"] = "error";
})(State || (State = {}));
export var BorderSize;
(function (BorderSize) {
    BorderSize["None"] = "border-none";
    BorderSize["Solid1"] = "border-solid-1";
})(BorderSize || (BorderSize = {}));
